/**
 * Left sidebar panel showing session details
 */
export const LiveSessionDetailsPanel = ({ session, isConsultant, otherPerson }) => {
  // Guard against null session
  if (!session) {
    return (
      <div className="lg:col-span-1 space-y-6">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Session Details</h3>
          <p className="text-sm text-gray-500 dark:text-gray-400">Loading session details...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="lg:col-span-1 space-y-6">
      
      {/* Session Info Card */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4 flex items-center">
          <svg className="w-5 h-5 mr-2 text-emerald-600 dark:text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Session Details
        </h3>
        
        <div className="space-y-3">
          <div>
            <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">
              {isConsultant ? 'User' : 'Consultant'}
            </label>
            <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
              {otherPerson?.name || 'Loading...'}
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400">{otherPerson?.email || ''}</p>
          </div>
          
          <div>
            <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Assessment Type</label>
            <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">{session?.assessment_type || 'N/A'}</p>
          </div>
          
          {session?.industry && (
            <div>
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Industry</label>
              <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">{session.industry.name}</p>
            </div>
          )}
          
          {session?.sub_industry && (
            <div>
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Sub-Industry</label>
              <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">{session.sub_industry.name}</p>
            </div>
          )}
          
          {session?.company_name && (
            <div>
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Company</label>
              <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">{session.company_name}</p>
            </div>
          )}
          
          <div>
            <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Started At</label>
            <p className="text-sm text-gray-900 dark:text-gray-100">
              {session?.started_at ? new Date(session.started_at).toLocaleString() : 'Not started'}
            </p>
          </div>
          
          {session?.ended_at && (
            <div>
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Ended At</label>
              <p className="text-sm text-gray-900 dark:text-gray-100">{new Date(session.ended_at).toLocaleString()}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

